module.exports = __webpack_public_path__ + "static/media/9.756e8c64.png";